import { List, Settings } from '@mui/icons-material';

export const routes = [
  {
    user: true,
    path: '/modifier-profil',
    name: 'Modifier mon profil',
    icon: Settings,
  },
  {
    path: '/annonces',
    name: 'Les annonces',
    icon: List,
  },
];
